<template>
    <div class="all">
        <div class="header">
            <div class="plan">
                <div class="rmb">{{mySettleInfo.yesterdayInRMB}}</div>
                <div class="rmbLabl">昨日预估收益</div>
            </div>

            <div class="statistics">
                <van-row class="onehang">
                    <van-col span="8">任务</van-col>
                    <van-col span="8">昨日</van-col>
                    <van-col span="8">累计</van-col>
                    <!--<van-col span="5">昨日Top</van-col>-->
                    <!--<van-col span="4">累计Top</van-col>-->
                </van-row>
                <template v-if="hasCountData">
                    <van-row v-for="item in jobList" :key="item.id"
                             v-if="indexCount.yesterdaySumMap[item.id] || indexCount.allSumMap[item.id]">
                        <van-col span="8">{{item.name}}</van-col>
                        <van-col span="8">
                            {{indexCount.yesterdaySumMap[item.id]?indexCount.yesterdaySumMap[item.id].sumValue:'0'}}
                        </van-col>
                        <van-col span="8">{{indexCount.allSumMap[item.id]?indexCount.allSumMap[item.id].sumValue:'0'}}</van-col>
                        <!--<van-col span="5">{{indexCount.yesterdayMaxMap[item.id]?indexCount.yesterdayMaxMap[item.id].maxValue:'0'}}</van-col>-->
                        <!--<van-col span="4">{{indexCount.allMaxMap[item.id]?indexCount.allMaxMap[item.id].maxValue:'0'}}</van-col>-->
                    </van-row>
                </template>
                <div class="noData" v-else> 暂无数据哦</div>
            </div>

        </div>

        <!-- <div class="center">
            <van-row>
                <van-col span="8"><strong>店员贡献</strong></van-col>
                <van-col span="8"><span>店员人数：221</span></van-col>
                <van-col span="8"><span>活跃店员：55</span></van-col>
            </van-row>

            <div class="noData" >
                  <div><i class="icon-task icon-ku"></i></div>
                  <div>暂无数据</div>
            </div>
        </div> -->

        <div class="buttom">
            <van-row>
                <van-col span="20">
                    <strong>完成明细</strong>
                </van-col>
                <van-col span="4">
                    <select v-model="month4selected" @change="handleMonth4Change">
                        <option v-for="(value,key) in month4SelecteMap" :key="key" :value="key">{{value}}</option>
                    </select>
                </van-col>
            </van-row>
            <van-row>
                <van-tabs v-model="jobActive" color="#ee9900" title-active-color="#ee9900" @change="jobChange">
                    <van-tab v-for="item in jobList" :title="item.name" :key="item.id">
                        <div class="table-box" v-if="logDetail.page.rows&&logDetail.page.rows.length>0">
                            <div style="margin: 0.2rem 0 0.5rem 0; color: #7d7e80;">
                                {{item.name}}：
                            </div>
                            <table>
                                <tr>
                                    <th>日期</th>
                                    <th>姓名</th>
                                    <th>裂变id</th>
                                    <!-- <th>手机号</th> -->
                                    <th>结算状态</th>
                                    <th v-for="(name,key1) in logDetail.detailMap" :key="key1">
                                        {{name}}
                                    </th>
                                </tr>
                                <tr v-for="(row,index) in logDetail.page.rows" :key="index"
                                    @click="upDetailShow(row.jobId,row.upStreamNo)">
                                    <td>{{row.settleDate | parseTime('{m}-{d}')}}</td>
                                    <td>{{row.traderName}}</td>
                                    <td>{{row.upPid}}</td>
                                    <!-- <td>{{row.traderPhone}}</td> -->
                                    <td>{{statusMap[row.status]}}</td>
                                    <td v-for="(name,key1) in logDetail.detailMap" :key="key1">
                                        {{row.upstreamFieldMap[key1]}}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="noData" v-else>
                            <div><i class="icon-task icon-ku"></i></div>
                            <div>暂无数据</div>
                        </div>

                    </van-tab>
                    <van-pagination v-model="queryLog.page" :total-items="logDetail.page.total"
                                    :items-per-page="queryLog.limit" @change="handlePageChange" mode="simple"/>
                </van-tabs>
            </van-row>
        </div>
        <van-popup v-model="upDetail.visible" position="bottom" style="height:400px;font-size: 11px">
            <table>
                <tr>
                    <th>序号</th>
                    <th>日期</th>
                    <th v-for="(name,key1) in upDetail.extFieldList" :key="key1">
                        {{name}}
                    </th>
                </tr>
                <tr v-for="(row,index) in upDetail.tableData" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{row.upSettleDate | parseTime('{m}-{d}')}}</td>
                    <td v-for="(name,key1) in upDetail.extFieldList" :key="key1">
                        {{row['ext'+(key1+1)]}}
                    </td>
                </tr>
            </table>
        </van-popup>
    </div>
</template>

<script>
    import countAPI from '@/api/count'

    export default {
        data() {
            return {
                selected: '',
                month12SelecteMap: {
                    "1": "一月",
                    "2": "二月",
                    "3": "三月",
                    "4": "四月",
                    "5": "五月",
                    "6": "六月",
                    "7": "七月",
                    "8": "八月",
                    "9": "九月",
                    "10": "十月",
                    "11": "十一月",
                    "12": "十二月"
                },
                month4SelecteMap: {
                    "3": "近三个月",
                    "6": "近半年",
                    "9": "近九个月",
                    "12": "近一年"
                },
                mySettleInfo: {
                    roleName: '门店店长',
                    balanceRMB: '0.00',
                    totalInRMB: '0.00',
                    yesterdayInRMB: '0.00'
                },
                hasCountData: false,
                indexCount: {
                    allSumMap: {},
                    allMaxMap: {},
                    yesterdaySumMap: {},
                    yesterdayMaxMap: {}
                },
                logDetail: {
                    detailMap: {},
                    page: {
                        rows: [],
                        total: 0
                    }
                },
                month4selected: '3',
                query: {},
                jobActive: null,
                jobList: [],
                queryLog: {
                    limit: 5,
                    page: 1,
                    jobId: null
                },
                upDetail: {
                    visible: false,
                    tableData: [],
                    extFieldList: []
                },
                statusMap: {
                    0: '待结算',
                    1: '结算中',
                    2: '已结算',
                }
            }
        },
        created() {
            this.$toast.loading({forbidClick: true});
            countAPI.jobList().then((result) => {
                this.jobList = result.data;
                if (this.jobList.length > 0) {
                    this.queryLog.jobId = this.jobList[0].id;
                    this.queryLogDetail();
                }
                this.index();
                this.$toast.clear();
            })
        },
        methods: {
            index() {
                this.$toast.loading({forbidClick: true})
                countAPI.index(this.query).then((result) => {
                    if (result.data.indexCount.allSumMap) {
                        for (var key in result.data.indexCount.allSumMap) {
                            this.hasCountData = true
                            break
                        }
                    }
                    this.mySettleInfo = result.data.mySettleInfo
                    this.indexCount = result.data.indexCount
                    this.$toast.clear()
                })
            },
            queryLogDetail() {
                this.$toast.loading({forbidClick: true});
                if (!isNaN(this.month4selected)) {
                    this.queryLog.startSettleDateStr = this.$myUtil.startDateStr(this.month4selected * 30)
                }
                countAPI.logDetail(this.queryLog).then((result) => {
                    this.logDetail = result.data;
                    this.$toast.clear()
                })
            },
            jobChange(index, title) {
                this.queryLog.jobId = this.jobList[index].id;
                this.queryLogDetail()
            },
            handlePageChange() {
                this.queryLogDetail()
            },
            handleMonth4Change() {
                this.queryLogDetail()
            },
            upDetailShow(jobId, upStreamNo) {
                countAPI.logUpDetail({
                    'jobId': jobId,
                    'upStreamNo': upStreamNo,
                    'limit': 300
                }).then((result) => {
                    this.upDetail.tableData = result.data.page.rows
                    this.upDetail.extFieldList = result.data.extFieldList
                    if (this.upDetail.tableData.length === 0) {
                        this.$toast('无明细数据')
                        return
                    }
                    this.upDetail.visible = true
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .header {
        padding: 0.5rem 0.2rem 1rem 0.2rem;
        margin: 0.5rem;
        background: -webkit-linear-gradient(left top, #ffca74, coral); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, #ffca74, coral); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, #ffca74, coral); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, #ffca74, coral); /* 标准的语法 */
        overflow: hidden;
        border-radius: 0.5rem;
        .plan {
            color: #FFFFFF;
            text-align: center;
            .rmb {
                font-size: 1.6rem;
                line-height: 3rem;
            }
            margin-bottom: 1rem;
        }
        .statistics {
            text-align: center;
            margin: 1rem 0.4rem 0.2rem 0.4rem;
            font-size: 1.1rem;
            background-color: #FFFFFF;
            .onehang {
                color: #8b9196;
            }
            .van-row {
                padding: 0.5rem;
                border-bottom: 1px solid #e5e5e5;
            }
            .noData {
                color: #B3B3B3;
                padding: 5rem;
            }
        }

    }

    select {
        float: right;
        text-align: center;
    }

    .center {
        border-top: 4px solid #f2f2f2;

        font-size: 1.1rem;
        padding: 1rem;
        .van-row {
            padding: 0.5rem 0rem;
            border-bottom: 1px solid #f2f2f2;
            span {
                font-size: 1rem;
                color: #8b9196;
            }
        }
        .statistics {
            clear: both;
        }
    }

    .buttom {
        border-top: 4px solid #f2f2f2;
        .van-row {
            margin: 1rem;
            font-size: 1.1rem;
        }

        .table-box {
            height: 16.7rem;
            overflow-x: scroll;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            color: #7d7e80;
            table tr td {
                text-align: center;
                line-height: 1.6rem;
            }
        }

        .van-pagination__item {
            color: #ee9900;
        }

        .noData {
            width: 6.9rem;
            height: 6.9rem;
            margin: 4rem auto 4rem auto;
            text-align: center;
            color: #E6E6E6;
            i {
                font-size: 5rem;
            }
        }

    }

</style>
